import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { CircleX } from 'lucide-react';

import CustomButton from '../Componentization/CustomButton';
import CustomText from '../../styles/CustomText';
import CustomTextInput from '../Componentization/CustomTextInput';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkMnemonic, checkQssMnemonic, RootState } from '../../store';

import * as bip39 from 'bip39'

const WalletRecovery: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	const { t } = useTranslation();
	let dispatch = useDispatch();

	const qssRestoreMnemonic = useSelector((state: RootState) => state.qssMnemonic.value);

	const [secretPhrase, setSecretPhrase] = useState<string>('')
	const [error, setError] = useState<boolean>(false)

	useEffect(() => {
		// setSecretPhrase(qssRestoreMnemonic)
		// redux 에 임시저장 니모닉 삭제
		// const temp = qssRestoreMnemonic

		// if(null != temp || '' != temp) {
		// 	// 복구단계 진행 시작
		// 	handleRecovery();
		// 	dispatch(checkQssMnemonic(''))
		// }
	}, [])

	useEffect(() => {
		setSecretPhrase(qssRestoreMnemonic)

		// redux 에 임시저장 니모닉 삭제
		const temp = qssRestoreMnemonic
		console.log(`qssRestoreMnemonic : ${qssRestoreMnemonic}`, qssRestoreMnemonic)
		dispatch(checkQssMnemonic(""))

		const trimmedSecretPhrase = temp.trim()
		const storeMnemonic = trimmedSecretPhrase.split(/\s+/)

		if (null != temp && '' !== temp) {
			// 복구단계 진행 시작
			if (bip39.validateMnemonic(trimmedSecretPhrase)) {
				setError(false)
				// redux 에 비밀복구코드 배열 임시 저장
				const jsonMnemonic = JSON.stringify(storeMnemonic)
				dispatch(checkMnemonic(jsonMnemonic))

				navigate(`/WalletRecoveryProtection`, { replace: true, state: { } });
			} else {
				setError(true)
				alert('Error validate Mnemonic');
			}
			// dispatch(checkQssMnemonic(''))
		}
	}, [])

	const handleRecovery = async () => {
		const trimmedSecretPhrase = secretPhrase.trim()
		const storeMnemonic = trimmedSecretPhrase.split(/\s+/)

		if (bip39.validateMnemonic(trimmedSecretPhrase)) {
			setError(false)
			// redux 에 비밀복구코드 배열 임시 저장
			const jsonMnemonic = JSON.stringify(storeMnemonic)
			dispatch(checkMnemonic(jsonMnemonic))

			navigate(`/WalletRecoveryProtection`, { replace: true, state: { } });
		} else {
			setError(true)
		}
	}

	const clearInput = () => {
		setSecretPhrase('')
		setError(false)
	}

	const styles = {
		header: {
			width: "100%",
			marginBottom: 20
		} as React.CSSProperties,
		title: {
			fontSize: 24,
			textAlign: 'left',
			marginBottom: 10
		} as React.CSSProperties,
		subtitle1: {
			fontSize: 18,
			textAlign: 'left'
		} as React.CSSProperties,
		subtitle2: {
			fontSize: 18,
			textAlign: 'left'
		} as React.CSSProperties,
		subtitle3: {
			fontSize: 18,
			textAlign: 'left',
			marginBottom: 5
		} as React.CSSProperties,
		warning1: {
			fontSize: 14,
			textAlign: 'left',
			marginTop: 10
		} as React.CSSProperties,
		warning2: {
			fontSize: 14,
			textAlign: 'left',
			marginBottom: 20
		} as React.CSSProperties,
		body: {
			width: "100%",
		} as React.CSSProperties,
		inputContainer: {
			border: `1px solid ${theme.line_alternative}`,
			borderRadius: 8,
			margin: "20px 0",
			display: 'flex',
			alignItems: 'center'
		} as React.CSSProperties,
		input: {
			fontSize: 16,
			height: 150,
			textAlignVertical: 'top'
		} as React.CSSProperties,
		inputError: {
			borderColor: theme.status_destrective
		} as React.CSSProperties,
		footer: {
			width: "100%",
			justifyContent: 'flex-end',
		} as React.CSSProperties,
		clearButton: {
			padding: 5
		} as React.CSSProperties,
		button: {
			borderRadius: 10,
			alignItems: 'center',
			width: '100%',
			height: 54,
			justifyContent: 'center'
		} as React.CSSProperties,
		buttonText: {
			fontSize: 16
		} as React.CSSProperties,
	}

	return (
		<div className='container' style={{ backgroundColor: theme.background_normal }}>
			<div style={styles.header}>
				<CustomText weight="medium" style={{ ...styles.title, color: theme.label_strong }}>
					{t('wallet_recovery_message_01')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle1, color: theme.label_strong }}>
					{t('wallet_recovery_message_02')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle2, color: theme.label_strong }}>
					{t('wallet_recovery_message_03')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle3, color: theme.label_strong }}>
					{t('wallet_recovery_message_04')}
				</CustomText>
				<CustomText style={{ ...styles.warning1, color: theme.label_alternative }}>
					{t('wallet_recovery_message_05')}
				</CustomText>
				<CustomText style={{ ...styles.warning2, color: theme.label_alternative }}>
					{t('wallet_recovery_message_06')}
				</CustomText>

				<div style={styles.body}>
					<div style={{ ...styles.inputContainer, ...(error && styles.inputError) }}>
						<CustomTextInput
							value={secretPhrase}
							onChangeText={setSecretPhrase}
							placeholder={t('wallet_recovery_message_07')}
							containerStyle={{ ...styles.input, color: theme.label_strong }}
							invalidStyle={styles.inputError}
							isValid={!error}
							useMultiLine={true}
						/>
						{secretPhrase.length > 0 && (
							<div onClick={() => clearInput()} style={styles.clearButton}>
								<CircleX size={20} color={theme.line_alternative} />
							</div>
						)}
					</div>
				</div>
			</div>

			<div style={styles.footer}>
				<CustomButton
					containerStyle={{ ...styles.button, backgroundColor: theme.primary_normal }}
					textStyle={styles.buttonText}
					onPress={handleRecovery}
					text={t('wallet_recovery_message_08')}
					disabled={secretPhrase.length <= 0}
					disabledStyle={secretPhrase.length > 0 ? { color: theme.static_white } : { backgroundColor: theme.primary_normal_disable, }}
					withBackground={true}
					backgroundColor={theme.primary_normal}
				/>
			</div>
		</div>
	)
}

export default WalletRecovery
